import { useEffect, useState } from "react";
import { isEmptyGameParams, useGameParamsContext } from "../stores/gameParams";
import { bridge } from "./bridge";

export const getAvatarId = (jwt: string): number | undefined => {
    try {
        const jwtParts = jwt.split(".");

        if (jwtParts.length !== 3) {
            return undefined;
        }

        const payload = JSON.parse(atob(jwtParts[1] ?? ""));

        if (!("avatarId" in payload)) {
            return undefined;
        }

        return payload.avatarId;
    } catch {
        return undefined;
    }
};

export const getExpirationDate = (jwt: string): Date | undefined => {
    try {
        const jwtParts = jwt.split(".");

        if (jwtParts.length !== 3) {
            return undefined;
        }

        const payload = JSON.parse(atob(jwtParts[1] ?? ""));

        if (!("exp" in payload)) {
            return undefined;
        }

        return new Date(payload.exp * 1000);
    } catch {
        return undefined;
    }
};

export function useJwt() {
    const [jwt, setJWT] = useState<string | null>(null);
    const { gameParams } = useGameParamsContext();

    // TODO: Deprecate gameParams and use getJWT instead, when available

    useEffect(() => {
        (async () => {
            const jwt = !isEmptyGameParams(gameParams)
                ? gameParams.jwt
                : undefined;

            if (!jwt) {
                console.error("No JWT available from gameParams");

                await bridge().then((b) => b.refreshJwt());
                return;
            }

            setJWT(jwt);
            console.log("Set JWT", jwt);

            const jwtExpiration = getExpirationDate(jwt);

            if (jwtExpiration && jwtExpiration < new Date()) {
                console.error("JWT is expired");
                await bridge().then((b) => b.refreshJwt());
                return;
            }
        })();
    }, [gameParams]);

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function handleJWTUpdate(e: any) {
            const { jwt } = e.detail;
            if (jwt) {
                setJWT(jwt);
                console.log("Set JWT", jwt);
            }
        }
        window.addEventListener("jwtUpdated", handleJWTUpdate);

        return () => {
            window.removeEventListener("jwtUpdated", handleJWTUpdate);
        };
    }, []);

    return jwt;
}
